//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Facet.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/FacetCollector.js";
let d=[[[0,"ConeAverageConstrainToDirectionToggle",1,0],[0,"ConeAverageConstrainToDirectionVector",1,"Direction",0],[0,"ConeColinearConstraintAxis",1,"Axis",0],[0,"ConeConstraintTypes",1,0],[1,"ConeHalfAngle",0,"Expression",0],[0,"ConeParallelConstraintVector",1,"Direction",0],[0,"CylinderAverageConstrainToDirectionToggle",1,0],[0,"CylinderAverageConstrainToDirectionVector",1,"Direction",0],[0,"CylinderColinearConstraintAxis",1,"Axis",0],[0,"CylinderConstraintTypes",1,0],[1,"CylinderOrSphereRadius",0,"Expression",0],[0,"CylinderParallelConstraintVector",1,"Direction",0],[0,"FacetCollector",0,"FacetCollector",0],[0,"HalfAngleToggle",1,0],[1,"MaxDeviation",0,"Expression",0],[0,"MinimumFacetNumber",1,0],[0,"OrthogonalOrCoplanarConstraintPlane",1,"Plane",0],[0,"PlaneAverageConstrainToNormalToggle",1,0],[0,"PlaneAverageConstrainToNormalVector",1,"Direction",0],[0,"PlaneConstraintTypes",1,0],[0,"PlaneParallelConstraintNormal",1,"Direction",0],[0,"RadiusToggle",1,0],[0,"ReplaceMeshOn",1,0],[0,"SphereConcentricConstraintPoint",1,"Point",0],[0,"SphereConstraintTypes",1,0],[0,"Type",1,0]],[],[]];
SPLM.Facet.ReplaceMeshWithFaceBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Facet.ReplaceMeshWithFaceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Facet.ReplaceMeshWithFaceBuilder.Types = Object.freeze({
    "Plane" : "Plane", "Cylinder" : "Cylinder", "Cone" : "Cone", "Sphere" : "Sphere"});

SPLM.Facet.ReplaceMeshWithFaceBuilder.PlaneConstraint = Object.freeze({
    "None" : "None", "Orthogonal" : "Orthogonal", "Parallel" : "Parallel", "Coplanar" : "Coplanar", "AverageParallel" : "AverageParallel", "AverageCoplanar" : "AverageCoplanar"});

SPLM.Facet.ReplaceMeshWithFaceBuilder.CylinderConstraint = Object.freeze({
    "None" : "None", "Parallel" : "Parallel", "Colinear" : "Colinear", "AverageParallel" : "AverageParallel", "AverageColinear" : "AverageColinear"});

SPLM.Facet.ReplaceMeshWithFaceBuilder.ConeConstraint = Object.freeze({
    "None" : "None", "Parallel" : "Parallel", "Colinear" : "Colinear", "AverageParallel" : "AverageParallel", "AverageColinear" : "AverageColinear"});

SPLM.Facet.ReplaceMeshWithFaceBuilder.SphereConstraint = Object.freeze({
    "None" : "None", "Concentric" : "Concentric", "AverageConcentric" : "AverageConcentric"});

SPLM.Facet.ReplaceMeshWithFaceBuilder.ReplaceMeshOnOption = Object.freeze({
    "OriginalBody" : "OriginalBody", "NewBody" : "NewBody"});

export default SPLM;